/** Reveal the complete confirmation after split-panel/composer layout changes. */
export const revealPlanningConfirmation = (message: HTMLElement): void => {
  const panel = message.closest<HTMLElement>('.ai-overview-panel, .planning-messages');

  if (!panel) return;
  const rect = panel.getBoundingClientRect();

  if (!rect.height) return;
  const composer = Array.from(document.querySelectorAll<HTMLElement>('.input-section'))
    .map((element) => element.getBoundingClientRect())
    .find((candidate) => candidate.height > 0 && candidate.left < rect.right && candidate.right > rect.left
      && candidate.top > rect.top && candidate.top < rect.bottom);
  const overlap = composer ? Math.max(0, rect.bottom - composer.top) : 0;

  panel.style.setProperty('--confirmation-composer-overlap', `${overlap}px`);
  const messageRect = message.getBoundingClientRect();
  const visibleBottom = Math.min(rect.bottom, composer?.top ?? rect.bottom) - 20;
  const below = messageRect.bottom - visibleBottom;
  const above = messageRect.top - rect.top - 12;

  // The submit action takes priority if an unusually short viewport cannot fit the whole form.
  if (below > 0) panel.scrollTop += below;
  else if (above < 0) panel.scrollTop += above;
};
